module.exports = __webpack_public_path__ + "static/kelly_bitmoji-4ebf39bda4e81612e310750d5cd790fb.png";